const wrapper = (props) => props.children;

export default wrapper;